import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm, SubmissionError } from 'redux-form'
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl'
import { CountrySelector } from 'components/forms'
import countries from 'components/forms/CountrySelector/countries'
import { Modal, Button } from 'components/util/'
import styles from './_countrySelect.css'

export const FORM_NAME = 'update_country'
const formOptions = {
  form: FORM_NAME,
}

class CountrySelect extends Component {
  static propTypes = {
    cancelCountryConfirmation: PropTypes.func,
    initiateCountryConfirmation: PropTypes.func,
    confirmCountry: PropTypes.string,
    intl: PropTypes.object,
    consentRegion: PropTypes.string,
    updateConsents: PropTypes.func,
    consentMatrix: PropTypes.object,
    fetchConsentMatrix: PropTypes.func,
    consent: PropTypes.object,
    matrixLoading: PropTypes.bool,
  }

  handleCountryChange = (country) => {
    this.props.fetchConsentMatrix(country)
    this.props.initiateCountryConfirmation(country)
  }

  handleUpdateConsents = (country) => {
    const {
      consentMatrix,
      updateConsents,
      consent: {
        accepted: {
          tos,
          required,
        },
      },
    } = this.props

    const existingConsents = {}
    const consentsArray = [...tos, ...required]

    consentsArray.forEach((term) => {
      existingConsents[term] = true
    })

    return updateConsents(consentMatrix.version, country, existingConsents)
      .then(() => {
        window.location.href = window.location.href
      })
      .catch((err) => {
        throw new SubmissionError({ _error: err.response.data.error })
      })
  }

  render () {
    const {
      consentRegion,
      intl,
      confirmCountry,
      cancelCountryConfirmation,
      matrixLoading,
    } = this.props

    return (
      <div>
        <CountrySelector
          slim
          name='gdpr_iso_code'
          onChange={this.handleCountryChange}
          labelComponent={ <FormattedMessage id='privacy_center.manage.country' defaultMessage="Country / Region where you currently live." /> }
          placeholder={ intl.formatMessage(countries[consentRegion.toLowerCase()]) }
        />

        <Modal isOpen={!!confirmCountry}>
          <div className={styles.modalContainer}>
            <h3 className={styles.modalHeader}>
              <FormattedMessage id='privacy_center.manage.confirm_country.title' defaultMessage="Confirm Country / Region Change" />
            </h3>
            <div className={styles.modalBody}>
              <FormattedHTMLMessage id='privacy_center.manage.confirm_country.body'
                defaultMessage={`
                <p>You have previously identified your Country / Region which were \
                used to determine the data privacy regulations that apply to you. \
                You should only change this value if it was entered incorrectly or you have moved.</p>
                <p>Changing this value may require you to accept applicable data \
                privacy consents if they differ from what exists.</p>`}
              />
            </div>
            <div className={styles.modalButtons}>
              <Button type='secondary' className={styles.cancelButton} onClick={cancelCountryConfirmation}>
                <FormattedMessage id='privacy_center.manage.confirm_country.cancel' defaultMessage="Cancel" />
              </Button>
              <Button
                type={matrixLoading ? 'secondary' : 'mmr' }
                className={styles.confirmButton}
                loading={matrixLoading}
                disabled={matrixLoading}
                onClick={matrixLoading ? null : () => { this.handleUpdateConsents(confirmCountry) }}
              >
                { matrixLoading ? null : <FormattedMessage id='privacy_center.manage.confirm_country.confirm' defaultMessage="Confirm Changes" /> }
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default injectIntl(reduxForm(formOptions)(CountrySelect))



// WEBPACK FOOTER //
// ./src/components/privacy_center/manage/CountrySelect.jsx